import React, { useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import MappingsPrintModal from './mappings-print';

const orangeSelectedStyle = {
  background: '#fff7e6',
  color: '#d48806',
  border: '1.5px solid #faad14',
  fontWeight: 600,
};

const PartsList = ({ 
  data, 
  selectedId, 
  onSelect, 
  onReceiveItem, 
  isShipmentClosed = false, 
  isPOMerged = true,
  receivingShipmentId = '',
  supplierName = '',
}) => {
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printModalPart, setPrintModalPart] = useState(null);

  const handlePrintLabelsClick = (part) => {
    setPrintModalPart(part);
    setShowPrintModal(true);
  };

  const handlePrintModalClose = () => {
    setShowPrintModal(false);
    setPrintModalPart(null);
  };

  const handlePrintModalSubmit = (formData) => {
    // You can add additional logic here if needed
    // The modal now handles the API call internally
  };

  return (
    <div className="list-group">
      {/* <h5 className="mb-3">Parts</h5> */}
      {data.map((part, index) => {
        // Check if requested quantity is greater than received quantity
        const requestedQty = part.quantityRequested || 0;
        const receivedQty = part.quantityReceived || 0;
        const receivedInThisShipment = part.receivedInThisShipment || 0;
        const hasReleases = part.releaseCount && part.releaseCount > 0;
        const showArrow = requestedQty <= receivedQty || hasReleases;
        return (
          <a
            href="#"
            key={part.poItemDetailID}
            className={`list-group-item list-group-item-action d-flex align-items-center`}
            style={selectedId === part.poItemDetailID ? orangeSelectedStyle : {}}
            onClick={e => { e.preventDefault(); onSelect(part.poItemDetailID); }}
          >
            <span className="flex-grow-1">
              <div>
                <strong>{part.partNumber || part.itemName}</strong>
                {part.poNumber && (
                  <small className="text-muted d-block">
                    PO: {part.poNumber}
                    {(part.description || part.itemName) &&
                      ` - ${part.description || part.itemName}`}
                  </small>
                )}
              </div>
            </span>
            {!showArrow && !part.isVoided ? (
              isPOMerged ? (
                <span
                  className="ms-2"
                  style={{ cursor: 'pointer', color: '#28a745', fontSize: 16 }}
                  title="Mark as Received"
                  onClick={e => {
                    e.stopPropagation();
                    onReceiveItem && onReceiveItem(part);
                  }}
                >
                  <FaArrowUp />
                </span>
              ) : (
                <span
                  className="ms-2"
                  style={{ cursor: 'not-allowed', color: '#bdbdbd', fontSize: 16, opacity: 0.6 }}
                  title="Merge this PO to receive items"
                >
                  <FaArrowUp />
                </span>
              )
            ) : null}
            {part.isVoided ? (
              <span className="ms-2 badge bg-danger">
                Voided: {receivedInThisShipment}
              </span>
            ) : ((!part.releaseCount || part.releaseCount === 0) && receivedInThisShipment && receivedInThisShipment !== 0) ? (
              <span className="ms-2 badge bg-success">
                Received: {receivedInThisShipment}
              </span>
            ) : null}
            {receivedInThisShipment > 0 && (!part.releaseCount || part.releaseCount === 0) && (
              <button
                className="btn btn-sm btn-outline-warning ms-2"
                onClick={e => {
                  e.stopPropagation();
                  handlePrintLabelsClick(part);
                }}
                title="Print labels for this part"
              >
                Print Labels
              </button>
            )}
          </a>
        );
      })}
      <MappingsPrintModal
        show={showPrintModal}
        onClose={handlePrintModalClose}
        onSubmit={handlePrintModalSubmit}
        poNumber={printModalPart?.poNumber || ''}
        partNumber={printModalPart?.partNumber || printModalPart?.itemName || ''}
        quantity={printModalPart?.receivedInThisShipment || ''}
        receivingShipmentId={receivingShipmentId}
        poReceivingId={printModalPart?.poReceivingID?.toString() || ''}
        partId={printModalPart?.partId ?? printModalPart?.itemID ?? null}
        poItemDetailId={printModalPart?.poItemDetailID?.toString() || ''}
        supplierName={
          printModalPart?.vendorName ||
          printModalPart?.supplierName ||
          printModalPart?.supName ||
          supplierName ||
          ''
        }
        userId={localStorage.getItem('UserId') || ''}
      />
    </div>
  );
};

export default PartsList;
